import { bindActionCreators } from 'redux';
import { EntityFiltersActions, ConfigActions, FuzzyActions, ServerListActions } from 'actions';

const mapDispatchToProps = (dispatch, ownProps) => {
    const entityName = ownProps.entity?.entity || '';
    const filterKey = ownProps.filterKey || entityName;
    const entityFiltersActions = bindActionCreators(EntityFiltersActions, dispatch);
    const setConfigWeb = bindActionCreators(ConfigActions, dispatch).setConfigWeb;

    return {
        initFilters: entityFiltersActions.initFilters,
        toggleFilters: (entity, state, force) =>
            entityFiltersActions.toggleFilters(entity, state, force, filterKey),
        changeFilter: (payload) => entityFiltersActions.changeFilter({ ...payload, filterKey }),
        changeAdvancedFilter: (payload) =>
            entityFiltersActions.changeAdvancedFilter({ ...payload, filterKey }),
        deleteMultipleFilters: (payload) =>
            entityFiltersActions.deleteMultipleFilters({ ...payload, filterKey }),
        clearFilters: (payload) => entityFiltersActions.clearFilters({ ...payload, filterKey }),
        saveCache: (config, partial) => setConfigWeb(`${filterKey}_filters`, config, partial),
        setConfigWeb,
        getFuzzy: bindActionCreators(FuzzyActions, dispatch).getFuzzy,
        getList: bindActionCreators(ServerListActions, dispatch).getList,
        removeView: entityFiltersActions.removeView,
        createView: entityFiltersActions.createView,
        setFilterDragging: (entity, filterId) =>
            entityFiltersActions.setFilterDragging(entity, filterId, filterKey),
        disableForceCrossFilters: (entity) =>
            entityFiltersActions.disableForceCrossFilters(entity, filterKey),
    };
};

export default mapDispatchToProps;
